import React from "react";
import * as styles from "./heroDetail.module.scss";
import Variant from "../../UI/Variant/variant";

const HeroDetail = ({ variant1, variant2, title, backgroundImage, news }) => {
  const sectionStyle = {
    backgroundImage: ` url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };

  return (
    <div className={styles.main_container}>
      <div className={styles.container}>
        <div className={styles.container_title}>
          <div className={styles.container_text}>
            <div className={styles.heroDetail__variants}>
              {news ? (
                <Variant
                  background="transparent"
                  text={news}
                  color="black"
                  border="black"
                  size="small"
                />
              ) : (
                <div className={styles.container_variants}>
                  <Variant
                    text={variant1}
                    color={"black"}
                    key={variant1}
                    background-color={"#ffffff1f"}
                  />

                  <Variant
                    text={variant2}
                    border="white"
                    color={"black"}
                    key={variant2}
                    background-color={"#ffffff1f"}
                  />
                </div>
              )}
            </div>

            <h1 className={styles.title}>{title}</h1>
          </div>
        </div>
        <div className={`${styles.heroDetail} flex`} style={sectionStyle}></div>
      </div>
    </div>
  );
};

export default HeroDetail;
